var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.833 20.8333H29.1667L41.6667 162.5L100 179.167L158.333 162.5L170.833 20.8333Z",
    fill: "#E65100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 33.3333V166.25L146.667 152.917L157.083 33.3333H100Z",
    fill: "#FF6D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 104.167V87.5001H135.833L132.917 135.417L100 146.25V128.75L117.083 122.917L118.333 104.167H100V104.167ZM137.083 70.8334L138.333 54.1667H100V70.8334H137.083Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 128.75V146.25L67.0833 135.417L65.4166 112.5H82.0833L82.9166 122.917L99.9999 128.75ZM79.5833 70.8334H99.9999V54.1667H62.0833L64.9999 104.167H99.9999V87.5001H80.8333L79.5833 70.8334Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.2b293fb4169ae5f818d27b6bb05a43f6.svg";
export { ForwardRef as ReactComponent };